<template>
  <div v-if="display" class="counter-section">
    <div class="counter-outer">
      <div class="countdown">
        <span class="number">{{ days }}</span>
        <span class="txt">DAYS</span>
      </div>
      <div class="dottle">.</div>
      <div class="countdown">
        <span class="number">{{ hours }}</span>
        <span class="txt">HOURS</span>
      </div>
      <div class="dottle">.</div>
      <div class="countdown">
        <span class="number">{{ minutes }}</span>
        <span class="txt">MINUTES</span>
      </div>
      <div class="dottle">.</div>
      <div class="countdown">
        <span class="number">{{ seconds }}</span>
        <span class="txt">SECONDS</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'timer',
  props: ['starttime', 'endtime'],
  data: function () {
    return {
      timer: '',
      wordString: {},
      start: '',
      end: '',
      interval: '',
      days: '',
      minutes: '',
      hours: '',
      seconds: '',
      display: true,
    };
  },
  mounted() {
    this.start = this.parseDateString(this.starttime.toLowerCase().replace('t', ' ')).getTime();
    this.end = this.parseDateString(this.endtime.toLowerCase().replace('t', ' ')).getTime();
    // Update the count down every 1 second
    this.timerCount(this.start, this.end);
    this.interval = setInterval(() => {
      this.timerCount(this.start, this.end);
    }, 1000);
  },
  methods: {
    timerCount: function (start, end) {
      const now = new Date().getTime();
      const distance = start - now;
      const timeDifference = end - now;

      if (new Date(this.endtime).getTime() > new Date().getTime()) {
        if (distance < 0 && timeDifference < 0) {
          this.display = false;
          clearInterval(this.interval);
          return;
        } else if (distance < 0 && timeDifference > 0) {
          // running
          this.display = true;
        } else if (distance > 0 && timeDifference > 0) {
          this.display = false;
        }
        this.calcTime(timeDifference);
        // end if
      } else {
        this.display = false;
      }
      // end funtion
    },
    calcTime: function (dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    },
    parseDateString(dateString) {
      let matchers = [];
      matchers.push(/^\d*$/.source);
      matchers.push(/(\d{1,2}\/){2}\d{4}( \d{1,2}(:\d{2}){2})?/.source);
      matchers.push(/\d{4}([/-]\d{1,2}){2}( \d{1,2}(:\d{2}){2})?/.source);
      matchers = new RegExp(matchers.join('|'));
      if (dateString instanceof Date) {
        return dateString;
      }
      if (String(dateString).match(matchers)) {
        if (String(dateString).match(/^\d*$/)) {
          dateString = Number(dateString);
        }
        if (String(dateString).match(/-/)) {
          dateString = String(dateString).replace(/-/g, '/');
        }
        return new Date(dateString);
      }
      return new Date(dateString);
    },
  },
};
</script>
